import { useState, useEffect } from "react";
import helpers from "utils/helpers";
import fetchData from "utils/fetchData";

const SelectFolder = ({ folder, setFolder }) => {
    const [folders, setFolders] = useState([]);

    useEffect(() => {
        const get_folders = async () => {
            const { data, error } = await fetchData({
                url: "folders", cache: true
            });

            if (!error) setFolders(data);
        }

        get_folders();
    }, []);

    return  <select required value={folder || ""} onChange={e => setFolder(e.target.value)}>
            <option value=""></option>
            {folders.filter(item => !folders.find(f => f.folders_id === item.id)).map(item => <option key={item.id} value={item.id}>
                {helpers.getPath(item.id, folders).map(p => p.name).join(" / ")}
            </option>)}
    </select>
}

export default SelectFolder;